import { Eye, X, Loader2 } from 'lucide-react';
import { useStudioStore } from '../../stores/studioStore';

export default function EditAsBanner() {
  const editAsBrandId = useStudioStore(s => s.editAsBrandId);
  const editAsBrandData = useStudioStore(s => s.editAsBrandData);
  const editAsLoading = useStudioStore(s => s.editAsLoading);
  const clearEditAs = useStudioStore(s => s.clearEditAs);

  if (!editAsBrandId) return null;

  const brandName = (editAsBrandData?.['ad.ad_school_brands.school_name']
    || 'Loading...') as string;
  const schoolName = (editAsBrandData?.['sm.sm_schools.name']
    || '') as string;
  const primaryColor = (editAsBrandData?.['ad.ad_school_brands.rgb_primary'] || '#06b6d4') as string;

  return (
    <div className="flex items-center gap-3 px-4 py-2 bg-gradient-to-r from-cyan-500/10 to-transparent border-b border-cyan-500/20 shrink-0">
      <div className="flex items-center gap-2">
        {editAsLoading ? (
          <Loader2 size={16} className="text-cyan-400 animate-spin" />
        ) : (
          <Eye size={16} className="text-cyan-400" />
        )}
        <span className="text-xs font-medium text-cyan-400 uppercase tracking-wider">
          Edit As
        </span>
      </div>

      <div className="flex items-center gap-2">
        <div
          className="w-4 h-4 rounded-full border border-white/20"
          style={{ backgroundColor: primaryColor }}
        />
        <span className="text-sm text-white font-medium">
          {brandName}
        </span>
        {schoolName && (
          <span className="text-sm text-white/50">
            — {schoolName}
          </span>
        )}
      </div>

      <div className="flex-1" />

      <button
        onClick={clearEditAs}
        className="flex items-center gap-1.5 px-2.5 py-1 text-xs text-white/60 hover:text-white bg-white/5 hover:bg-white/10 rounded transition-colors"
      >
        <X size={14} />
        Exit Preview
      </button>
    </div>
  );
}
